// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__7vNXq","columnsContiner":"App_columnsContiner__+39F7"};